export default function (file, types) {
  const name = file.name;
  const extension = name.substr(name.lastIndexOf('.'), name.length).toLowerCase();
  const isValid = types.indexOf(extension.replace(/^\./, '')) !== -1;

  return { isValid, extension };
}
